import {useState} from "react";

interface SizeFiltersProps {
    selectedSizes: string[];
    getUniqueSizes: () => string[];
    addSize: (size: string) => void;
    removeSize: (size: string) => void;
}

export default function SizeFilters({
    selectedSizes,
    getUniqueSizes,
    addSize,
    removeSize
}: SizeFiltersProps) {
    const [isFolderActive, setIsFolderActive] = useState<boolean>(false);

    const isSizeActive = (inSize: string) => {
        return selectedSizes.includes(inSize)
    }

    return (
        <>
            <div className="all-filters-block all-filters-block--size">
                <div className="all-filters__accord">
                    <p className={"all-filters__title all-filters__link f-exp " + (isFolderActive && 'active')}
                       onClick={() => {
                           setIsFolderActive(!isFolderActive)
                       }}>Размер <i
                        className="ico ico-arrow-bot-b"></i></p>
                    {isFolderActive && <div className="all-filters__col">
                        <div className="all-filters__height">
                            <ul className="all-filters-sizes">
                                {getUniqueSizes().map(size => <li key={size}>
                                    <div className={"form-checkbox " + (isSizeActive(size) && "active")}>
                                        <label className={"label-dot " + (size.length > 4 ? "label-long" : '')}
                                               onClick={() => {
                                                   isSizeActive(size) ? removeSize(size) : addSize(size)
                                               }}>{size}</label>
                                    </div>
                                </li>)}
                            </ul>
                        </div>
                    </div>}
                </div>
            </div>
            <ul className="all-filters__activated">
                {selectedSizes.map(size => <li key={size}><a className="ico-cont" href="/" onClick={(event) => {
                    event.preventDefault()
                    removeSize(size)
                }}>{size}<i className="ico ico-right ico-delete"></i></a></li>)}
            </ul>
        </>
    );
}